const t = {
  name: "Prague",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 9V6H0V18L5 18V17C5 15.9493 5.94554 15 7 15C8.05446 15 9 15.9493 9 17V18H15V17C15 15.9493 15.9455 15 17 15C18.0545 15 19 15.9493 19 17V18L24 18V6H22V9L13 9V6H11V9L2 9ZM2 11L22 11V16L20.866 16C20.4057 14.3054 18.8172 13 17 13C15.1828 13 13.5943 14.3054 13.134 16H10.866C10.4057 14.3054 8.81717 13 7 13C5.18283 13 3.59434 14.3054 3.13403 16L2 16L2 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Prague
};
